/** @format */
import React, { useContext } from 'react';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { ProductConditionValue } from '@toucan/client/global/product';

import { ProductConditionDescriptionModal } from './components/product-condition-description-modal';

export function useProductConditionDescriptionModal() {
    const { setModalVisible, setModalContent } = useContext(ApplicationContext);

    const showProductConditionDescriptionModal = (
        condition: ProductConditionValue,
        conditionDescription: string
    ) => {
        setModalContent(
            <ProductConditionDescriptionModal
                condition={condition}
                conditionDescription={conditionDescription}
                onClose={() => setModalVisible(false)}
            />
        );
        setModalVisible(true, {
            size: ModalSize.MEDIUM,
        });
    };

    return {
        showProductConditionDescriptionModal,
    };
}
